import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'antd'
import css from './contact-mapping.css'

const ForwardingInfo = ({
  additionalRecipients,
  locationCountryCode,
  officeEmail,
  officePhone,
  onAdditionalRecipientsChange,
  onInputChange,
  requiresPhoneNumberPurchase,
  showAdditionalRecipients,
}) => {
  const countryPhoneCode = (countryCode => {
    switch (countryCode) {
      case 'AU':
        return '+61'
      case 'IE':
        return '+353'
      case 'NZ':
        return '+64'
      case 'IT':
        return '+39'
      case 'ZA':
        return '+27'
      default:
        return '+1'
    }
  })(locationCountryCode)

  return (
    <div className={css.officeContactInfo}>
      {requiresPhoneNumberPurchase && (
        <div className={css.phoneOrEmailWrapper}>
          <span className={css.labelSmall}>Office phone</span>
          <span className={css.md}>
            <Input
              className={css.input}
              value={officePhone}
              name="officePhone"
              onChange={onInputChange}
              addonBefore={countryPhoneCode}
            />
          </span>
        </div>
      )}
      <div className={css.phoneOrEmailWrapper}>
        <span className={css.labelSmall}>Office email</span>
        <span className={css.md}>
          <Input
            className={css.input}
            value={officeEmail}
            name="officeEmail"
            onChange={onInputChange}
          />
        </span>
      </div>
      {showAdditionalRecipients && (
        <div className={css.phoneOrEmailWrapper}>
          <span className={css.labelSmall}>Additional Recipients</span>
          <span className={css.md}>
            <Input
              className={css.input}
              value={additionalRecipients}
              name="additionalRecipients"
              onChange={onAdditionalRecipientsChange}
            />
          </span>
        </div>
      )}
    </div>
  )
}

ForwardingInfo.propTypes = {
  additionalRecipients: PropTypes.string,
  locationCountryCode: PropTypes.string.isRequired,
  officeEmail: PropTypes.string,
  officePhone: PropTypes.string,
  onAdditionalRecipientsChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  requiresPhoneNumberPurchase: PropTypes.bool.isRequired,
  showAdditionalRecipients: PropTypes.bool.isRequired,
}

ForwardingInfo.defaultProps = {
  officeEmail: '',
  officePhone: '',
  additionalRecipients: '',
}

export default ForwardingInfo



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/ForwardingInfo.js